import './customer-services.component.scss'
import '../../application/sea-forms/index.scss'
import { scrollTo } from '../../application/utils/scroll-to'

const navigation = document.querySelector('.customer-navigation')
const content = document.querySelector('.customer-content')

function parseState(state = '') {
  state = state.replace('#', '').replace('contact_form','client-care')
  return state.split('@').filter((state) => state !== '')
}

function createState(tabName, sectionName) {
  let state = ''
  if (tabName) state += tabName
  if (sectionName) state += `@${sectionName}`
  return state
}

function stateToggle(root, attribute, value) {
  const current = root.querySelectorAll(`[${attribute}].is-active`)
  const target = root.querySelector(`[${attribute}="${value}"]`)
  current.forEach((node) => node.classList.remove('is-active'))
  if (target) target.classList.add('is-active')
}

function tabHandler(tabName) {
  stateToggle(navigation, 'data-tab-name', tabName)
  stateToggle(content, 'data-tab-name', tabName)
  navigation.querySelectorAll('[data-section-name][class]').forEach((node) => node.removeAttribute('class'))
}

function sectionHandler(sectionName) {
  const target = content.querySelector(`[data-section-name="${sectionName}"]`)
  if (target) scrollTo(target, true)
}

function linkHandler(target) {
  navigation.querySelectorAll('[data-section-name][class]').forEach((node) => node.removeAttribute('class'))
  target.setAttribute('class','')
}

function clickHandler(tabName,sectionName) {
  if (tabName) tabHandler(tabName)
  if (sectionName) {
    sectionHandler(sectionName)
  } else if (tabName) {
    const target = content.querySelector(`[data-tab-name="${tabName}"]`)
    if (target) scrollTo(target, true)
  }
  if(tabName || sectionName) window.location.hash = createState(tabName, sectionName)
}

if (navigation && content) {
  navigation.addEventListener('click', (event) => {
    event.preventDefault()
    const { tabName, sectionName } = event.target.dataset
    clickHandler(tabName,sectionName)
    if (sectionName) linkHandler(event.target)
  })
  const savedState = parseState(window.location.hash)

  if (savedState.length > 0) {
    tabHandler(savedState[0])
    if (savedState[1]) sectionHandler(savedState[1])
  } else {
    const tabName = navigation.querySelector('[data-tab-name]')?.dataset.tabName
    //console.log(tabName)
    if (tabName) tabHandler(tabName)
  }
  document.addEventListener('click', (event) => {
    const { hash } = event.target.dataset
    if(hash){
      event.preventDefault()
      const hashA = hash.split('--')
      clickHandler(hashA[0],hashA[1])
      if(document.documentElement.classList.contains('is-menu'))
        document.querySelector('.header-button[data-navigation]').click()
    }
  })
  /*window.addEventListener('hashchange', function() {
    if(window.location.hash.indexOf('@') === -1){
      const savedState = parseState(window.location.hash)
      if (savedState.length > 0) {
        tabHandler(savedState[0])
        if (savedState[1]) sectionHandler(savedState[1])
      } else {
        const tabName = navigation.querySelector('[data-tab-name]')?.dataset.tabName
        console.log(tabName)
        if (tabName) tabHandler(tabName)
      }
    }
  }, false);*/

}
